namespace Solovis.Reports.ReportHelpers.ReportLibrary {

    export class ReportListExpandedTreeControl extends Solovis.UI.BaseControl {
        private _reportListDataSet;
        private _userHasReportEditPermission

        private _nodeIdToExpandedMap = {};        

        constructor(options) {
            super(options);

            this._reportListDataSet = options.reportListDataSet;
            this._userHasReportEditPermission = options.userHasReportEditPermission;

            this.expandAll();
            this._nodeIdToExpandedMap["folder---/Featured Links"] = false;
            this._nodeIdToExpandedMap["folder---/Featured Links (Shared)"] = false;
        }

        public doRender() {
            let self = this;

            let rootNode = this._reportListDataSet.rootNode;            

            let expandCollapseList = []

            let createDivForNodeReports = function (treeNode) {
                if (treeNode.entryList && treeNode.entryList.length > 0) {
                    var div = $("<div>");

                    $(treeNode.entryList).each(function (i, entry: any) {
                        var reportDiv = ReportLibraryReportGenerator._createReportDiv(entry.name, entry, self._userHasReportEditPermission);
                        if (i % 2 == 1) {
                            reportDiv.css("background-color", "#eee");
                        }

                        div.append(reportDiv);
                    });

                    return div;
                }
                else {
                    return null;
                }
            };

            let createDeeplyNestedFolderDivs = function (container, treeNode) {
                if (treeNode.nodes && treeNode.nodes.length > 0) {
                    $(treeNode.nodes).each(function (i, folderNode: any) {
                        var folderBanner = $("<div>").appendTo(container)
                            .addClass("report-path-banner-level-deep");

                        folderBanner.text(folderNode.name);

                        var reportListDiv = createDivForNodeReports(folderNode);
                        if (reportListDiv) {
                            reportListDiv.css("padding-left", "10px");
                            container.append(reportListDiv);
                        }

                        createDeeplyNestedFolderDivs(container, folderNode);
                    });
                }
            };

            let createSecondLevelFolderDivs = function (container, treeNode) {
                let folderContainerDiv = $("<div>").appendTo(container);

                if (treeNode.nodes && treeNode.nodes.length > 0) {
                    $(treeNode.nodes).each(function (i, folderNode: any) {
                        let folderCell = $("<div>").appendTo(folderContainerDiv)
                            .addClass("report-path-container-level-2");

                        let folderBanner = $("<div>").appendTo(folderCell)
                            .addClass("report-path-banner-level-2");

                        folderBanner.text(folderNode.name);

                        let reportListDiv = createDivForNodeReports(folderNode);
                        folderCell.append(reportListDiv);                        

                        createDeeplyNestedFolderDivs(folderCell, folderNode);
                    });
                }

                return folderContainerDiv;
            };

            let createTopLevelFolderDivs = function (container, treeNode) {
                if (treeNode.nodes && treeNode.nodes.length > 0) {
                    $(treeNode.nodes).each(function (i, folderNode: any) {
                        let folderBanner = $("<div>").appendTo(container)
                            .addClass("report-path-banner-level-1");

                        folderBanner.text(folderNode.name);

                        let reportListDiv = createDivForNodeReports(folderNode);
                        container.append(reportListDiv);

                        if (reportListDiv) {
                            reportListDiv.css("margin-bottom", "10px");
                        }

                        let folderContainerDiv = createSecondLevelFolderDivs(container, folderNode);

                        let expandCollapseSpan = $("<span class='fa'>").css("padding-left", "5px").css("cursor", "pointer").appendTo(folderBanner);
                        let expandCollapseItem = {
                            nodeId: folderNode.nodeId,
                            controlSpan: expandCollapseSpan,
                            
                            updateDisplay: function () {
                                let expanded = self._nodeIdToExpandedMap[this.nodeId];                                
                                if (expanded) {
                                    this.controlSpan.removeClass("fa-chevron-right");
                                    this.controlSpan.addClass("fa-chevron-down");
                                }
                                else {
                                    this.controlSpan.removeClass("fa-chevron-down");
                                    this.controlSpan.addClass("fa-chevron-right");                                    
                                }

                                $(reportListDiv).toggle(expanded);
                                $(folderContainerDiv).toggle(expanded);
                            },

                            toggle: function (newExpanded?) {
                                if (typeof (newExpanded) === "undefined") {
                                    let expanded = self._nodeIdToExpandedMap[this.nodeId];
                                    self._nodeIdToExpandedMap[this.nodeId] = !expanded;
                                }
                                else {
                                    self._nodeIdToExpandedMap[this.nodeId] = newExpanded;
                                }
                                this.updateDisplay();
                            }
                        };

                        expandCollapseSpan.click(() => {
                            expandCollapseItem.toggle();
                        });

                        expandCollapseItem.updateDisplay();
                        expandCollapseList.push(expandCollapseItem);
                    });
                }
            };

            var reportListDiv = createDivForNodeReports(rootNode);
            this.container.append(reportListDiv);

            if (reportListDiv) {
                reportListDiv.css("margin-top", "10px");
            }

            createTopLevelFolderDivs(this.container, rootNode);
        }

        public expandAll() {
            let self = this;

            let expandNode = function (node) {
                self._nodeIdToExpandedMap[node.nodeId] = true;
                if (node.nodes) {
                    for (let childNode of node.nodes) {
                        expandNode(childNode);
                    }
                }
                
            };

            expandNode(this._reportListDataSet.rootNode);
        }
    }

}